import { IHsaPicture } from "../../hsa/types"
import { ImportDocument } from "../../omnia"

type Doc = ImportDocument

export class HsaPictureVM {

    importDocumentHsaId: number
    hsaId: number
    pictureId: number
    picture: Doc
    comment: string
    index: number

    public static create(model: IHsaPicture): HsaPictureVM {
        var vm = new HsaPictureVM()

        vm.importDocumentHsaId = model.HsaPictureId
        vm.hsaId = model.HsaId
        vm.pictureId = model.DocumentId
        vm.picture = model.Document
        vm.comment = model.Comment
        vm.index = model.Index

        return vm
    }

    public static createNew(picture: Doc, index: number, hsaId: number): HsaPictureVM {
        var vm = new HsaPictureVM()

        vm.hsaId = hsaId
        vm.picture = picture
        vm.pictureId = picture.ImportDocumentId
        vm.index = index

        return vm
    }

    getModel(): IHsaPicture {
        return {
            HsaPictureId: this.importDocumentHsaId,
            DocumentId: this.pictureId,
            HsaId: this.hsaId,
            Comment: this.comment,
            Index: this.index
        }
    }
}
